/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

var networkSingleTemplate = require('../../templates').networkSingleTemplate;
var groupedTemplate = require('../../templates').groupedTemplate;
var smartGroupedTemplate = require('../../templates').smartGroupedTemplate;
var rootScope = require('./root-scope.service');
var submitButtonServices = require('./submit-button');
var _ = require('underscore');
var translate = require('./translate.service');

const showPresetText = (presetAccount) => {
    if (!presetAccount) return false;
    return presetAccount.registered === false && presetAccount.autoRegistration === false && presetAccount.allowRecurrence === false;
};

const addNetworkCodeToNetworks = (networksGroup) => {
    _.each(networksGroup, function (aNetwork) {
        aNetwork.networkCode = aNetwork.code;
    });
};
/*
 * Get Networks Snippet of HTML
 */
function createANetwork(networksGroup, type, smartSwitch, templateName, isCardView = false) {
    addNetworkCodeToNetworks(networksGroup);

    networksGroup['groupType'] = type;

    if (rootScope.getIsSingleMethod()) {
        networksGroup.length === 1 ? (networksGroup[0]['isSingle'] = true) : (networksGroup['isSingle'] = true);
    }

    networksGroup.length === 1 ? (networksGroup[0]['isCardView'] = isCardView) : (networksGroup['isCardView'] = isCardView);
    networksGroup['cardsTitle'] = translate('groups.cards.title');

    return networksGroup.length == 1
        ? networkSingleTemplate(networksGroup[0], templateName)
        : smartSwitch
        ? smartGroupedTemplate(networksGroup, templateName)
        : groupedTemplate(networksGroup, templateName);
}

function createNetworksList(networks, smartSwitch, templateName) {
    const isCardView = rootScope.isCardView() == 'true' ? true : false;
    var networkList = '';

    _.each(networks, function (networksGroup, type) {
        networkList += createANetwork(networksGroup, type, smartSwitch, templateName, isCardView);
    });

    return networkList;
}

function getNetworksList(networks, smartSwitch, templateName) {
    if (_.isEmpty(networks)) {
        return '';
    }

    return createNetworksList(networks, smartSwitch, templateName);
}

function getNetworkByCode(networks, code) {
    var res = {};
    _.each(networks, function (networksGroup) {
        if (_.isEmpty(res)) {
            res = _.findWhere(networksGroup, { code: code });
        }
    });
    return res;
}

function getSelectedNetworkInList(networks) {
    var res = {};
    _.each(networks, function (networksGroup) {
        if (_.isEmpty(res)) {
            res = _.findWhere(networksGroup, { selected: true });
        }
    });
    return res;
}

/**
 * Gets selected network.
 * The result of this method is a last selected network on the payment page or selected network in List object.
 * @returns selected network.
 */
function getLastSelectedNetwork() {
    var networks = rootScope.getAllNetworks();
    var lastSelected = getNetworkByCode(networks, rootScope.getSelectedNetwork());
    if (lastSelected) {
        return lastSelected;
    }

    return getSelectedNetworkInList(networks);
}

/**
 * Pre-check some selected network.
 */
function preCheckSelectedNetwork() {
    var radioButton = null;
    var preselectedNetwork = getLastSelectedNetwork();
    var presetAccount = rootScope.getPresetAccount();
    var accounts = rootScope.getAllAccounts();
    var networks = rootScope.getAllNetworks();
    var needToSelectFirst = !(_.isEmpty(presetAccount) && _.isEmpty(accounts) && _.size(networks) !== 1);

    var networkSelectors = rootScope.getListContainer().find('input');
    if (preselectedNetwork && preselectedNetwork.networkCode) {
        _.each(networkSelectors, function (networkSelector, i) {
            if (
                networkSelector.id == 'paymentType' + preselectedNetwork.networkCode ||
                networkSelector.id == 'paymentType' + preselectedNetwork.grouping
            ) {
                radioButton = networkSelectors.eq(i);
            }
        });
    }

    if (radioButton == null && needToSelectFirst) {
        radioButton = networkSelectors.eq(0);
    }
    // if a payment method option should be selected
    // Do that by triggering click on radio button
    // translation of submit button will then happen at the stage
    if (radioButton != null) {
        radioButton.prop('checked', true);
        radioButton.click();
    } else {
        //show generic button depending on operationType
        rootScope.getSubmitButton().html(submitButtonServices.getGenericButtonLabel());
        // disable the button
        submitButtonServices.disableSubmitButton();
        //make sure to display the main button
        rootScope.getSubmitButton().show();
    }
}

module.exports = {
    getNetworksList: getNetworksList,
    getNetworkByCode: getNetworkByCode,
    getSelectedNetworkInList: getSelectedNetworkInList,
    getLastSelectedNetwork: getLastSelectedNetwork,
    preCheckSelectedNetwork: preCheckSelectedNetwork,
    showPresetText: showPresetText,
};
